'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuickSendItem = exports.processQuickSends = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _isArray3 = require('lodash/isArray');

var _isArray4 = _interopRequireDefault(_isArray3);

var _find3 = require('lodash/find');

var _find4 = _interopRequireDefault(_find3);

var _reselect = require('reselect');

var _projects = require('helpers/projects');

var _Playlists = require('helpers/Playlists');

var _TypeCast = require('helpers/TypeCast');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getProjects = function getProjects(state) {
  return state.quicksend.qsListData;
};
var getProjectParams = function getProjectParams(state) {
  for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return params;
};

var processQuickSends = exports.processQuickSends = (0, _reselect.createSelector)([getProjects], function (projects) {
  // duct tape for API different responses for different box types
  var qsProjects = [];
  if ((0, _isArray4.default)(projects)) {
    qsProjects = projects;
  }
  if ((0, _get4.default)(projects, 'albums')) {
    qsProjects = [].concat((0, _toConsumableArray3.default)(projects.albums));
    qsProjects.map(function (qsProject) {
      qsProject.tracks = (0, _get4.default)(projects, ['tracks', qsProject.project_id], []);
    });
  }

  return (0, _projects.processProjects)(qsProjects);
});

var getQuickSendItem = exports.getQuickSendItem = (0, _reselect.createSelector)([processQuickSends, getProjectParams], function (projects, params) {
  var id = params[0];
  var qsProject = (0, _find4.default)(projects, { projectId: id }) || {};
  var processedProject = (0, _projects.processProject)(qsProject);
  processedProject.tracks = processedProject.tracks ? (0, _Playlists.processTracks)({ tracks: (0, _TypeCast.asArray)(processedProject.tracks) }) : [];
  return processedProject;
});


//////////////////
// WEBPACK FOOTER
// ./src/selectors/quicksend.js
// module id = 532
// module chunks = 1